export default __webpack_public_path__ + "static/media/Ali.f08c8f92.jpeg";